module.exports = __webpack_public_path__ + "static/media/nav-icon-campaigns.f6116476.svg";